import React from 'react'
import queryString from 'query-string'
import { useLocation } from 'react-router-dom'
import { ButtonList, LinkButton, Wrapper } from './StartPage'
import { categories } from '../data/cardInfo'
import smileIcon from '../img/emojis/smiley.svg'
import starfaceIcon from '../img/emojis/starface.svg'
import coolIcon from '../img/emojis/cool.svg'
import styled from 'styled-components'

const Emoji = styled.img`
  width: 10em;
  margin: -1rem;
`

const ScoreText = styled.div`
  margin-bottom:1rem;
`
const ResultText = styled.div`
  max-width: 20em;
`

const QuizResult = () => {

  const location = useLocation()
  console.log(location)
  const {score} = queryString.parse(location.search)

  const result = (score >= 5) ? (
    {icon: coolIcon, text: 'Du har ju stenkoll!'}
  ) : (score >= 3) ? (
    {icon: starfaceIcon, text: 'Snyggt jobbat! Vill du testa igen?'}
  ) : (
    {icon: smileIcon, text: 'Det är klurigt det här, testa gärna igen eller träna mer på begreppen.'}
  )
  return (
    <Wrapper>
      <Emoji src={result.icon} alt=""/>
      <ScoreText><b>Du fick {score} poäng.</b></ScoreText>
      <ResultText>{result.text}</ResultText>
      <ButtonList>
        <LinkButton color={categories[2].topColor} to='/'>Tillbaka till början</LinkButton>
        <LinkButton color={categories[2].bottomColor} to='/difficulty'>Spela igen</LinkButton>
      </ButtonList>
    </Wrapper>
  )
}

export default QuizResult
